import { useDeviceType } from '@cian/ui-kit';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { STONE_3SP_DESKTOP_EXPERIMENT_ENABLED_KEY } from '../../../constants/config';
import { STONE_BANNER } from '../../../constants/stone';
import { selectMapBounds } from '../../../selectors/mapBounds';
import { selectParentRegionId } from '../../../selectors/parentRegionId';
import { selectJsonQuery } from '../../../selectors/results';
import { TAdfoxMapBannerConfig, TAdfoxMapBannerConfigItem } from '../../../types/adfoxMapBannerConfig';
import { IApplicationState } from '../../../types/redux';
import { getAdfoxBannerConfig } from '../../../utils/bannerPackages';
import { useApplicationContext } from '../../ApplicationContext';

export function useSelectedAdfoxBannerConfig(): TAdfoxMapBannerConfigItem | null {
  const deviceType = useDeviceType();
  const jsonQuery = useSelector(selectJsonQuery);
  const { zoom } = useSelector(selectMapBounds);
  const adfoxMapBannerConfig = useSelector((state: IApplicationState) => state.config.adfoxMapBannerConfig);
  const parentRegionId = useSelector(selectParentRegionId);
  const { config } = useApplicationContext();

  /**
   * Баннер Stone показываем только при включённом фичатоггле Martech.Stone3SPDesktopExperiment.Enabled.
   * Если тоггл выключен или не задан — баннера нет.
   */
  const isStoneBannerEnabled = !!config.get<boolean>(STONE_3SP_DESKTOP_EXPERIMENT_ENABLED_KEY);

  const adfoxEnabled = config.get<boolean>('mapSearchFrontend.AdfoxMapBanner.Enabled') || false;

  const filteredConfig = useMemo<TAdfoxMapBannerConfig>(() => {
    return adfoxMapBannerConfig.filter(item => {
      if (item.developerId === STONE_BANNER.developerId) {
        return isStoneBannerEnabled;
      }

      return true;
    });
  }, [adfoxMapBannerConfig, isStoneBannerEnabled]);

  return getAdfoxBannerConfig({
    zoom,
    jsonQuery,
    deviceType,
    adfoxEnabled,
    adfoxMapBannerConfig: filteredConfig,
    parentRegionId,
  });
}
